export default __webpack_public_path__ + "static/automate-dont-2-0e84f14600a8cb88de78cb9673f49516.png";